import { Link, LinkProps } from "react-router-dom";
import { forwardRef, MouseEvent } from "react";

/**
 * A Link that performs a hard navigation (full page reload) 
 * when EN mode is active to avoid Google Translate DOM conflicts.
 */
const HardLink = forwardRef<HTMLAnchorElement, LinkProps>(
  ({ to, onClick, ...props }, ref) => {
    const handleClick = (e: MouseEvent<HTMLAnchorElement>) => {
      const lang = localStorage.getItem("language");
      
      if (lang === "en") {
        e.preventDefault();
        // Convert "to" prop to string path
        const path = typeof to === "string" ? to : to.pathname || "/";
        window.location.href = path;
        return;
      }
      
      // In NL mode, let React Router handle it normally
      onClick?.(e);
    };

    return <Link ref={ref} to={to} onClick={handleClick} {...props} />;
  }
);

HardLink.displayName = "HardLink";

export default HardLink;
